import React from 'react';
import PropTypes from 'prop-types';
import Message from '../message/Message';

const PlayerXP = ({level, xp}) => {
    const levelClass = `xpLevelImageClass xpLevelRankStar${level > 0 ? (Math.min(Math.max((level / 10), 1), 5)) : 0}`;
    return (
        <div className="rankRow">
            <div className="statColumn"><Message code="epic.ut.stats.exp_level" /></div>
            <div className="xpColumn">
                <div className={levelClass} />
                <div className="xpLevelClass">{level}</div>
            </div>
            <div><Message code="epic.ut.stats.xp_total" args={[xp]} /></div>
        </div>
    )
}

PlayerXP.propTypes = {
    level: PropTypes.number,
    xp: PropTypes.number
}

export default PlayerXP
